// main.ts
import { enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component'; // Standalone AppComponent
import { environment } from './environments/environment';

// Angular modules and services
import { BrowserModule } from '@angular/platform-browser';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';

import { SharedModule } from './app/shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { OAuthModule } from 'angular-oauth2-oidc';
import { ServiceWorkerModule } from '@angular/service-worker';
import { appRoutes } from './app/routes';
import { AuthGuard } from './app/auth/auth.guard';
import { SecurityQuestionService } from './app/services/security-question.service';
import { UserService } from './app/services/user.service';
import { DataService } from './app/services/data.service';
import { AccountService } from './app/services/account.service';
import { CookieService } from 'ngx-cookie-service';
import { CommunicationService } from './app/services/communication.service';
import { AuthInterceptor } from './app/auth/auth.interceptor';
import { SapiService } from './app/services/sapiservice.service';
import { FormatTimePipe } from './app/helpers/pipe/format-time.pipe';
import { AppInsightsService } from './app/services/appinsights.service';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { ChatService } from './app/services/chat.service';
import { InputValidationService } from './app/helpers/validators/input-validation.service';
import { Helper } from './app/helpers/helper';
import { CMSService } from './app/services/cms.service';

// Update this with actual import paths

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(
      BrowserModule,
      SharedModule,
      NgbModule,
      NgxSpinnerModule,
      NgIdleKeepaliveModule.forRoot(),
      OAuthModule.forRoot({
        resourceServer: {
          allowedUrls: [environment.webApiUrl],
          sendAccessToken: true
        }
      }),
      ServiceWorkerModule.register('ngsw-worker.js', {
        enabled: environment.enableServiceWorker
      })
    ),

    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(appRoutes, withInMemoryScrolling({ scrollPositionRestoration: 'enabled' })),
    provideAnimations(),

    // Services
    AuthGuard,
    SecurityQuestionService,
    UserService,
    DataService,
    AccountService,
    CookieService,
    CommunicationService,
    InputValidationService,
    ChatService,
    CurrencyPipe,
    DatePipe,
    AppInsightsService,
    FormatTimePipe,
    SapiService,
    Helper,
    CMSService,

    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ]
}).then(() => {
  if ('serviceWorker' in navigator && environment.enableServiceWorker) {
    navigator.serviceWorker.register('/ngsw-worker.js');
  }
}).catch(err => console.error(err));
